import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { tap } from "rxjs/operators";
import { IEngineerJobItem } from "../../../foundation.interfaces";
import { EngineerJobItemService } from "../../../_services/engineer-job-item.service";

@UntilDestroy()
@Component({
    selector: 'job-completion',
    template: `<v-progress-bar [total]="total" [count]="count" subject="{{ 'EngineerJobs.JobItems' | translate }}"></v-progress-bar>`
})

export class JobCompletionComponent implements OnInit, OnChanges {
    @Input() jobId: number;

    //--

    count: number = 0;
    total: number = 0;

    jobItems: IEngineerJobItem[];

    constructor(private readonly jobItemService: EngineerJobItemService) { }

    ngOnInit(): void {
        this.getData();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['jobId']) {
            this.getData();
        }
    }

    //--

    private getData(): void {
        this.jobItemService.getEngineerJobItems({ JobId: this.jobId }).pipe(
            untilDestroyed(this),
            tap(jobItems => {
                this.jobItems = jobItems;
                this.calculateTotals();
            })
        ).subscribe()

    }

    private calculateTotals(): void {
        const { completedJobItems, totalJobItems } = this.jobItemService.calculateJobCompletion(this.jobItems);
        this.total = totalJobItems;
        this.count = completedJobItems;
    }
}
